import { FC } from "react";
import { NormalizedCostWidgetAggregations } from "@/components/pages/dashboard/components/widgets/normalized-cost-widget/components/NormalizedCostWidgetAggregations";
import { useAppSelector } from "@/store/hooks";
import { normalizedCostWidgetSetupSelector } from "@/store/dashboards/selectors/setups/normalized-cost-widget/normalizedCostWidgetSetupSelector";
import { normalizedCostWidgetSetupDataSelector } from "@/store/dashboards/selectors/widgets/normalized-cost-widget/setup/normalizedCostWidgetSetupDataSelector";

export const NormalizedCostWidgetSetupAggregations: FC = () => {
  const setup = useAppSelector(normalizedCostWidgetSetupSelector);
  const data = useAppSelector(normalizedCostWidgetSetupDataSelector);

  if (!setup) {
    return;
  }

  return (
    <NormalizedCostWidgetAggregations
      totalCost={data?.total_cost}
      totalCostTrend={data?.trend}
      aggregations={setup.aggregation}
      forecastOption={setup.forecastOption}
      forecastedCosts={data?.forecasted_costs}
      averageNormalizedMonthlyCost={data?.average_normalized_monthly_cost}
    />
  );
};
